'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _head2 = require('lodash/head');
var _head3 = _interopRequireDefault(_head2);
var _get2 = require('lodash/get');
var _get3 = _interopRequireDefault(_get2);
exports.default = accessors;
var _constants = require('../utils/constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function accessors(target) {
  target.accessors = (0, _extends3.default)({}, target.accessors, {
    layerSeries: function layerSeries(data) {
      return (0, _get3.default)((0, _head3.default)(data), 'layerSeries', []);
    },
    rectStrokeColor: function rectStrokeColor(options) {
      return (0, _get3.default)(options, 'stacked.strokeColor', null);
    },
    rectStrokeThickness: function rectStrokeThickness(options) {
      return (0, _get3.default)(options, 'stacked.strokeThickness', null);
    },
    colorCoeff: function colorCoeff(datum, options) {
      var isFocused = target.accessors.isFocused(datum);
      var coeffKey = isFocused ? 'focusColorCoeff' : 'colorCoeff';
      return (0, _get3.default)(options, 'stacked.layerSeries[' + datum.layerIndex + '].' + coeffKey, null);
    },
    focusData: function focusData(datum) {
      if (target.accessors.isABaseline(datum)) return {
        index: target.accessors.baselineIndex(datum),
        type: _constants.BASELINE
      };else if (target.accessors.isHighlighted(datum)) return {
        index: target.accessors.highlightIndex(datum),
        type: _constants.HIGHLIGHT
      };
      return {
        index: (0, _get3.default)(datum, 'layerIndex', 0)
      };
    }
  });
}